"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Erc1155Section = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const icons_material_1 = require("@mui/icons-material");
const react_router_dom_1 = require("react-router-dom");
const react_intl_1 = require("react-intl");
const ui_kit_1 = require("@dzambalaorg/ui-kit");
const data = [
    { text: "pages.erc1155.contracts.title", link: "/erc1155/contracts", icon: (0, jsx_runtime_1.jsx)(icons_material_1.Collections, {}) },
    { text: "pages.erc1155.templates.title", link: "/erc1155/templates", icon: (0, jsx_runtime_1.jsx)(icons_material_1.Storage, {}) },
];
const Erc1155Section = () => {
    return ((0, jsx_runtime_1.jsx)(material_1.Paper, { sx: { mb: 2 }, children: (0, jsx_runtime_1.jsx)(ui_kit_1.List, { component: "nav", subheader: (0, jsx_runtime_1.jsx)(ui_kit_1.List.Subheader, { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "pages.dashboard.hierarchy.erc1155" }) }), children: data.map(({ text, icon, link }) => ((0, jsx_runtime_1.jsxs)(ui_kit_1.List.ItemButton, { component: react_router_dom_1.Link, to: link, children: [(0, jsx_runtime_1.jsx)(ui_kit_1.List.ItemIcon, { children: icon }), (0, jsx_runtime_1.jsx)(ui_kit_1.List.ItemText, { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: text }) })] }, text))) }) }));
};
exports.Erc1155Section = Erc1155Section;
//# sourceMappingURL=erc1155.js.map